<header
  class="sticky top-0 inset-x-0 flex flex-wrap sm:justify-start sm:flex-nowrap z-10 w-full bg-chemPrimaryForeground text-sm py-2.5 dark:bg-neutral-800 dark:border-neutral-700">
  <nav class="flex basis-full items-center w-full mx-auto px-4 sm:px-4" aria-label="Global">
    <div class="lg:hidden">
      <div class="flex items-center">
        <button (click)="$event.stopPropagation(); onClickedToggleSidebar()" mat-icon-button
          class="!w-[37px] !h-[37px] me-1 !p-0 !text-white">
          <mat-icon>menu</mat-icon>
        </button>
        <b class="text-lg font-bold text-white">Chemical Common Settings</b>
      </div>
    </div>

    <div class="lg:w-full flex items-center justify-end ms-auto sm:justify-between sm:gap-x-3 sm:order-3">
      <div class="hidden sm:block">
        <div class="hidden sm:block">
          <div class="flex items-center">
            <button (click)="$event.stopPropagation(); onClickedToggleSidebar()" mat-icon-button
              class="!w-[37px] !h-[37px] me-1 !p-0 !text-white">
              <mat-icon>menu</mat-icon>
            </button>
            <b class="text-lg font-bold text-white">Chemical Common Settings</b>
          </div>
        </div>
      </div>

      <div class="flex flex-row items-center justify-end gap-2">
        <div class="hs-dropdown [--placement:bottom-right] relative inline-flex">
          <app-profile-menu></app-profile-menu>
        </div>
      </div>
    </div>
  </nav>
</header>